// store/hydration.ts
import { useStore } from './index';

export async function hydrateAuthStore() {
  console.log('🔄 Starting hydration process...');

  // E2E shortcut: if Playwright injected a token into localStorage, use it directly.
  // This avoids reliance on single-use refresh tokens that get rotated.
  const e2eToken = localStorage.getItem('e2e_access_token');
  if (e2eToken) {
    try {
      console.log('🔄 Found E2E access token, using it directly...');
      await useStore.getState().login({ accessToken: e2eToken, skipExpiryCheck: true });
      console.log('✅ Hydration via E2E token completed successfully');
      return;
    } catch (e2eError) {
      console.warn('⚠️ E2E token login failed, falling back to refresh...', e2eError);
      localStorage.removeItem('e2e_access_token');
    }
  }

  try {
    console.log('🔄 Attempting silent refresh...');
    const newToken = await useStore.getState().refreshAccessToken();
    await useStore.getState().login({ accessToken: newToken });
    console.log('✅ Hydration completed successfully');
  } catch (error) {
    console.warn('⚠️ Silent refresh failed, continuing as unauthenticated.', error);
    useStore.setState({ 
      userProfile: null, 
      accessToken: null, 
      hydrated: true 
    });
  }
}
